import {
  AfterViewInit,
  Directive,
  ElementRef,
  Input
  } from '@angular/core';
// TODO: Replace with css fit text
@Directive({
    selector: "[fit-text]",
    standalone: true,
})
export class FitTextDirective implements AfterViewInit {
  /**
   * The ratio to use for size of text.
   *
   * @return {number}
   */
  @Input() compressor = 1;

  /**
   * The minimum font size.
   *
   * @return {number}
   */
  @Input() minFontSize: number = Number.NEGATIVE_INFINITY;

  /**
   * The maximum font size.
   *
   * @return {number}
   */
  @Input() maxFontSize: number = Number.POSITIVE_INFINITY;

  /**
   * If parent should be used for sizing.
   *
   * @return {boolean}
   */
  @Input() useParent = false;

  /**
   * Create a new instance of the directive.
   *
   * @param  {ElementRef} element
   */
  constructor(private element: ElementRef) {}

  /**
   * After view init.
   */
  ngAfterViewInit(): void {
    this.fitText();
    setTimeout(() => this.fitText(), 250);
  }

  /**
   * Make text in the card fit the right size.
   *
   * @return {void}
   */
  fitText(): void {
    const e = this.useParent
      ? this.element.nativeElement.parentElement
      : this.element.nativeElement;

    if (!e.offsetWidth) {
      return;
    }

    const size = Math.max(
      Math.min(e.offsetWidth / (this.compressor * 10), this.maxFontSize),
      this.minFontSize
    );

    this.element.nativeElement.style.fontSize = size + "px";
  }
}
